var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanetsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 33,
    height: 33,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9994 17L10.9994 23M25.9924 16.63C26.0435 17.8731 25.8363 19.1133 25.3839 20.2723C24.9315 21.4312 24.2437 22.4838 23.364 23.3636C22.4843 24.2433 21.4317 24.9311 20.2727 25.3835C19.1137 25.8359 17.8735 26.0431 16.6304 25.992L25.9924 16.63ZM16.9994 8C18.7158 7.99966 20.3964 8.49002 21.8432 9.41329C23.2901 10.3366 24.4428 11.6542 25.1654 13.211L13.2104 25.166C11.3497 24.3038 9.83913 22.832 8.92899 20.9941C8.01884 19.1563 7.76366 17.0628 8.20569 15.0601C8.64773 13.0575 9.76047 11.2659 11.3597 9.98198C12.9589 8.69805 14.9486 7.99879 16.9994 8Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetsIcon);
export default __webpack_public_path__ + "static/media/planetsIcon.c9632aa2b38dbb02a56cec42ce1e869a.svg";
export { ForwardRef as ReactComponent };